import { useQuery } from '@tanstack/react-query';
import { onboardingApi } from './api';

export const stationReadinessKey = (stationId?: string) =>
  ['station-readiness', stationId ?? 'none'] as const;

/**
 * Live per-logbook readiness for a station. Drives the just-in-time onboarding
 * gates and the dashboard checklist. Disabled until a station is selected.
 */
export const useStationReadiness = (stationId?: string) =>
  useQuery({
    queryKey: stationReadinessKey(stationId),
    queryFn: () => onboardingApi.getStationReadiness(stationId as string),
    enabled: Boolean(stationId),
    staleTime: 30_000
  });
